import MusicActionTypes from './music.types';

const INITIAL_STATE = {
    songs: [],
    isFetching: true,
    errorMessage: undefined,
	isPlaying: false,
};

const musicReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case MusicActionTypes.FETCH_MUSIC_START:
            return {
                ...state,
                songs: [],
                isFetching: true,
            };
        case MusicActionTypes.FETCH_MUSIC_SUCCESS:
            return {
                ...state,
                songs: action.payload,
                isFetching: false
            };
        case MusicActionTypes.FETCH_MUSIC_FAILURE:
            return {
                ...state,
                isFetching: false,
                errorMessage: action.payload
            };
		case MusicActionTypes.PLAY_MUSIC:
			if (state.isPlaying) return state; // ✅ Prevent re-dispatch when already playing
			  return {
				...state,
				isPlaying: true,
			};
		case MusicActionTypes.RESET_TRIGGER:
			  return {
				...state,
				isPlaying: false,
			};
        default:
            return state;
    }
};

export default musicReducer;
